module.exports = __webpack_public_path__ + "img/header.413c067a.jpg";